module.exports = __webpack_public_path__ + "img/icons_37.14bf7f59.png";